.info-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2.4rem;
}

.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
}

.fields-scroll-area {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 2.4rem;
  overflow-y: auto;
  padding: 0 2.4rem 3.2rem 2.4rem;

  @media screen and (min-width: $bp-medium) {
    padding-bottom: 2.4rem;
  }
}

.button-wrapper {
  display: none;

  @media screen and (min-width: $bp-medium) {
    display: flex;
    justify-content: flex-end;
    padding: 0 2.4rem 2.4rem;
  }
}

.select-wrapper {
  position: relative;
  width: 100%;
}

.profile-avatar-wrapper {
  margin: 0 auto;
  position: relative;
}
